import React, { useState, useEffect } from 'react';
import SearchHotelsWidget from '../../../shared/components/SearchHotelsWidget';
import tourvisorAPI from '../../api/tourvisorAPI';
import SearchHotelsWidgetOpen from '../../../shared/components/SearchHotelsWidgetOpen';

function onlyUnique(value, index, array) {
  return array.indexOf(value) === index;
}

function subregionsHotels(hotels = [], subregions = []) {
  const filterSubregions = [];
  if (!subregions.length) {
    return hotels;
  } else {
    hotels.map((hotel) => {
      if (subregions.includes(hotel.subregion)) {
        filterSubregions.push(hotel);
      }
    });
    return filterSubregions;
  }
}

const Hotels = ({
  value = [],
  onChoose,
  onReset,
  country,
  stars,
  rating,
  regions = [],
  subregions = [],
  recomend,
  onRecomend,
  onSetRecommend,
  onSetRating,
  isOpen = true,
  autoSearch = false,
  onSetWithReviews,
  hotelsIdWithReviews,
  setHotelsIdWithReviews,
  hasReviews,
}) => {
  const [hotels, setHotels] = useState(value);
  const [title, setTitle] = useState(
    value.length ? `Выбрано отелей: ${value.length}` : 'Выберите отель'
  );
  let [items, setItems] = useState([]);
  let [recomendList, setRecomendList] = useState([]);
  const [resetData, setResetData] = useState(false);
  const [isWidgetOpened, setWidgetOpened] = useState(isOpen);

  const checkedSubregions = subregions.length ? subregions : '';

  useEffect(() => {
    const getHotels = async (params) => {
      let requestQuery = new URLSearchParams(params).toString();
      const res = await tourvisorAPI.dics('hotel', requestQuery);
      const hotelsList = res.lists.hotels.hotel;
      const filtredHotelsList = subregionsHotels(hotelsList, subregions);
      setItems(filtredHotelsList);
    };

    if (isWidgetOpened) {
      getHotels({
        hotcountry: country,
        hotstars: stars && stars > 1 ? stars : '',
        hotregion: regions,
        hotrating: rating,
      });
    }
  }, [isWidgetOpened, country, stars, regions, rating, checkedSubregions]);

  useEffect(() => {
    if (isWidgetOpened) {
      setHotelsIdWithReviews();
    }
  }, [country, isWidgetOpened]);

  useEffect(() => {
    if (resetData === true) {
      setHotels([]);
      onChoose([]);
      setResetData(false);
    }
  }, [resetData]);

  useEffect(() => {
    const getRecomendHotels = async (countryId) => {
      const res = await tourvisorAPI.getRecommendedHotels(countryId);
      const hotelsList = res.map((h) => `${h.tourvisor_id}`);
      setRecomendList(hotelsList);
      onRecomend(hotelsList);
      return [];
    };

    if (isWidgetOpened) {
      getRecomendHotels(country);
    }
  }, [country, onRecomend, isWidgetOpened]);

  useEffect(() => {
    if (recomend && recomendList.length && !hotels.length) {
      const recArr = [...recomendList.filter(onlyUnique)];
      setHotels(optionsArr);
      onChoose(optionsArr);
    }
  }, [
    country,
    stars,
    regions.length,
    subregions.length,
    rating,
    recomend,
    onChoose,
    items,
  ]);

  useEffect(() => {
    if (hasReviews && hotelsIdWithReviews.length && !hotels.length) {
      setHotels(optionsArr);
      onChoose(optionsArr);
    }
  }, [
    country,
    stars,
    regions.length,
    subregions.length,
    rating,
    hasReviews,
    onChoose,
    items,
  ]);

  useEffect(() => {
    setHotels(value);
  }, [value]);

  useEffect(() => {
    if (value && value.length == 1) {
      setTitle('Выбран 1 отель');
    } else if (value.length < 1) {
      setTitle(`Выберите отель`);
    } else if (value && value.length < 5) {
      setTitle(`Выбрано ${value.length} отеля`);
    } else if (value && value.length > 4) {
      setTitle(`Выбрано отелей: ${value.length}`);
    }
  }, [value.length]);

  function handleReset() {
    setResetData(true);
    setHotels([]);
    onReset([]);
  }

  const setHotelsOnChooseCollection = (hotelsIds) => {
    onChoose(hotelsIds);
  };

  const setHotelsOnChoose = (v) => {
    const h = [...hotels].filter(onlyUnique);
    const index = h.indexOf(v);

    if (index !== -1) {
      h.splice(index, 1);
    } else {
      h.push(v);
    }
    setHotels(h, onChoose(h));
  };

  let options = items.map((item, idx) => {
    const rec = recomendList.indexOf(item.id) != -1 ? true : false;
    return { id: item.id, name: `${item.name} ${item.stars}*`, recomend: rec };
  });

  let optionsArr = options.map((option) => {
    return option.id;
  });

  if (recomend) {
    options = options.filter((opt) => opt.recomend);
    optionsArr = options.map((option) => {
      return option.id;
    });
  }

  if (hasReviews) {
    const hotelsArr = [];
    items.forEach((item) => {
      if (hotelsIdWithReviews.indexOf(item.id) !== -1 ? true : false) {
        hotelsArr.push({ id: item.id, name: `${item.name} ${item.stars}*` });
      }
    });
    optionsArr = hotelsArr.map((opt) => opt.id);
    options = hotelsArr;
  }

  let hotels_fix = [];
  hotels_fix = hotels.filter(onlyUnique);

  const wasChange = !value.length ? false : true;
  return isOpen ? (
    <SearchHotelsWidgetOpen
      type="virtualized"
      label="Название отеля"
      title={`${title}`}
      items={options}
      value={hotels_fix}
      hasFilter={true}
      buttonReset={true}
      onReset={handleReset}
      cssClass="hotels"
      width={'unset'}
      country={country}
      onChoose={setHotelsOnChoose}
      isChanged={wasChange}
      onChooseCollection={setHotelsOnChooseCollection}
      recomend={recomend}
      onRecomend={onSetRecommend}
      onSetWithReviews={onSetWithReviews}
      recomendList={recomendList}
    />
  ) : (
    <SearchHotelsWidget
      isWidgetOpened={isWidgetOpened}
      setWidgetOpened={setWidgetOpened}
      type="virtualized"
      label="Название отеля"
      title={`${title}`}
      items={options}
      value={hotels_fix}
      hasFilter={true}
      buttonReset={true}
      onReset={handleReset}
      cssClass="hotels"
      width={350}
      country={country}
      recomend={recomend}
      rating={rating}
      onChooseCollection={setHotelsOnChooseCollection}
      isChanged={wasChange}
      onChoose={setHotelsOnChoose}
      onSetRating={onSetRating}
      recomendList={recomendList}
      onRecomend={onSetRecommend}
      hasReviews={hasReviews}
      onSetWithReviews={onSetWithReviews}
      hotelsIdWithReviews={hotelsIdWithReviews}
    />
  );
};

export default Hotels;
